package com.shadowings.gero.presentation.model

import com.shadowings.gero.domain.model.Message
import com.shadowings.gero.domain.model.UserData

data class IntroUiState(
    val userData: UserData = UserData(),
    val messages: List<Message> = emptyList(),
    val currentMessageIndex: Int = 0
)

sealed interface IntroEffect {
    data object NavigateToMain : IntroEffect
    data object ScrollToBottom : IntroEffect
}
